<template>
  <Portal>
    <Modal
      data-testid="continue-registration-modal"
      :is-open="isOpen"
      title=""
      @close="handleClose"
    >
      <div class="continue-registration-modal__content">
        <HelperViewContextual
          icon="ED0040"
          status="info"
          title="Falta pouco para você começar a investir!"
          description="Finalize o seu cadastro para fazer seu primeiro investimento na Warren."
        />
      </div>
      <template #buttonContainer>
        <ButtonContainer>
          <template #button-primary>
            <ButtonPrimary
              label="Continuar cadastro"
              @click="handleContinue"
            />
          </template>
        </ButtonContainer>
      </template>
    </Modal>
  </Portal>
</template>

<script setup lang="ts">
import {
  ButtonPrimary,
  ButtonContainer,
  Modal,
  HelperViewContextual,
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';

defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits(['close']);

function handleClose() {
  emit('close');
}

function handleContinue() {
  const { domain, platform } = getDomainAndPlatform();
  window.location.href = `/onboarding/${domain}/${platform}/states/register-personal`;
}
</script>

<style lang="less" scoped>
.continue-registration-modal {
  &__content {
    padding: @size-spacing-x800 @size-spacing-x800 @size-spacing-x600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

:deep(.modal-content) {
  padding: 0;
  align-items: flex-start;
}

:deep(.button-container) {
  button,
  .button--ui {
    background-color: @element-primary !important;
    color: @base-primary !important;
  }
}
</style>
